import React from "react";
import { AppBtn } from "../../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../../ui/modal-full";
import { StoreInterface } from "@/assets/interfaces";

interface Props {
  store: StoreInterface;
  show: boolean;
  toggle: (state: boolean) => void;
}

const RefundPolicyModal: React.FC<Props> = ({ store, show, toggle }) => {
  return (
    <Modal {...{ show, toggle }} fullOnlyOnMobile title="Return & Refund Policy" bgClose={false}>
      <ModalBody className="py-0 sm:py-0">
        <div className="py-4.5 sm:py-4.5 md:py-4.5 lg:py-4.5  py-1 space-y-5">
          <div className="w-full flex flex-col">
            <h6 className="text-base sm:text-base md:text-base lg:text-base font-bold text-black">Refund Policy</h6>
            <p className="leading-snug text-dark transition-all ease-out duration-200 text-1sm md:text-sm lg:text-sm mt-3 ">
              {store?.extra_info?.refund_policy}
            </p>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RefundPolicyModal;
